module.exports = __webpack_public_path__ + "static/media/game(22).3a8961bf.PNG";